import React from "react";
import { Spinner } from 'reactstrap';

const Loader = ({ color = "dark", size = { width: 100, height: 100 }, className = "font-size-xlg" }) => {
    return (
        // style = {{ top: '50%', left: '50%', position: 'absolute' }}
        <Spinner animation="grow" color={color} className={className} style={{ width: size?.width, height: size?.height }} />
    )
};

export default Loader;